(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GSF", [], factory);
	else if(typeof exports === 'object')
		exports["GSF"] = factory();
	else
		root["GSF"] = factory();
})(window, function() {
return 